export const TABLE_VIEW_REGIME = {
  board: 'board',
  split: 'split',
  table: 'table',
}

export const TABLE_VIEW_REGIME_LABEL_KEY = {
  [TABLE_VIEW_REGIME.board]: 'Table.ViewRegimeBoardKey',
  [TABLE_VIEW_REGIME.split]: 'Table.ViewRegimeSplitKey',
  [TABLE_VIEW_REGIME.table]: 'Table.ViewRegimeTableKey',
}

export const QA_NAME_TABLE_VIEW_REGIME_SECTION = 'viewRegime'
